import { render, staticRenderFns } from "./updateEmployee.vue?vue&type=template&id=64739daa"
import script from "./updateEmployee.vue?vue&type=script&lang=js"
export * from "./updateEmployee.vue?vue&type=script&lang=js"
import style0 from "./updateEmployee.vue?vue&type=style&index=0&id=64739daa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports